// src/modules/Rules/adapters/ProductsApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';
import type { Option } from './ConditionApiAdapter';
import globalCache from '../../../../shared/lib/GlobalCache';

export class ProductsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<Option[]> {
    return globalCache.getOrSet('products', async () => {
      const raw = await this.httpClient.get<any>('/products', { fields: 'basic' });
      // Puede venir [{…}, …] o { data: […] }
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((p: any) => ({
        id: String(p.id),
        // ajusta aquí al campo que venga en tu JSON, p.ej. p.name, p.title, etc.
        name: p.name,
      }));
    });
  }
}
